import React from 'react';

export const Header = () => {
    return null
}


// WEBPACK FOOTER //
// ./src/components/modules/HeaderContent.js